export default __webpack_public_path__ + "static/media/Poppins-Thin.59ff6a72.ttf";